import { observable } from "mobx";
import { Type } from "class-transformer";
import { startOfDay, subDays } from "date-fns";
import type { EntityValidationRules } from "../services/validationService";

export class BlacklistedEmailAddressCreateRequest {
  @observable
  emailAddressSearchPattern: string = "";

  @observable
  description?: string;

  @observable
  @Type(() => Date)
  validSinceDate?: Date;

  @observable
  @Type(() => Date)
  validUntilDate?: Date;
}

export class BlacklistedEmailAddressUpdateRequest {
  @observable
  description?: string;

  @observable
  @Type(() => Date)
  validUntilDate?: Date;

  @observable
  hasImmediateEndOfValidity?: boolean;

  @observable
  validUntilActionType?: "NONE" | "CHANGE" | "DELETION";
}

export const BlacklistedEmailAddressCreateValidationRules: EntityValidationRules<BlacklistedEmailAddressCreateRequest> = {
  emailAddressSearchPattern: {
    required: true,
    isLength: { min: 3, max: 300 },
    isValidRegex: true,
  },
  description: {
    isLength: { max: 500 },
  },
  validSinceDate: {
    required: true,
    isAfter: {
      condition: () => subDays(startOfDay(new Date()), 1),
      customMessage: "notInPast",
    },
  },
  validUntilDate: {
    isAfter: {
      condition: (request: BlacklistedEmailAddressCreateRequest) => {
        if (request.validSinceDate) {
          return subDays(startOfDay(request.validSinceDate), 1);
        }
        return undefined;
      },
      customMessage: "notBeforeValidSince",
    },
  },
};

export const BlacklistedEmailAddressUpdateValidationRules: EntityValidationRules<BlacklistedEmailAddressUpdateRequest> = {
  description: {
    isLength: { max: 500 },
  },
};

// Validační pravidla pro editaci BlacklistedEmailAddress entity
export const BlacklistedEmailAddressEditValidationRules = {
  description: {
    isLength: { max: 500 },
  },
  validUntil: {
    isAfter: {
      condition: (entity: { validSince?: Date }) => {
        const yesterday = subDays(startOfDay(new Date()), 1);
        if (entity.validSince) {
          const validSinceMinusOne = subDays(startOfDay(entity.validSince), 1);
          // Vrátí pozdější datum - validUntil musí být po validSince i po včerejšku
          return yesterday > validSinceMinusOne ? yesterday : validSinceMinusOne;
        }
        return yesterday;
      },
      customMessage: "notBeforeValidSince",
    },
  },
};
